import React from 'react';
import ForbiddenContainer from '../containers/ForbiddenContainer';

export default function RouteForbbiden(props){
    return <ForbiddenContainer {...props} />;
}